import { z } from 'zod';

export const ProductSchema = z.object({
  id_certificate: z.coerce.number().int(),
  id_state: z.coerce.number().int(),
  description: z.string(),
  amount: z.coerce.number(),
  updated_at: z.union([z.string(), z.date()]).nullable().optional(),
});


export const ProductsApiResponseSchema = z.object({
  ok: z.boolean(),
  certificates: z.array(ProductSchema),
});

export type Product = z.infer<typeof ProductSchema>;
export type ProductsApiResponse = z.infer<typeof ProductsApiResponseSchema>;
